import { createApi } from "@reduxjs/toolkit/query/react";

import { axiosBaseQuery } from "./axiosBaseQuery";

export const evrApi = createApi({
  reducerPath: "ervApi",
  baseQuery: axiosBaseQuery(),
  endpoints: () => ({}),
});
